module.exports = __webpack_public_path__ + "components/flag/static/square/fj-fb9f2ba55e945cbeb8597cb2ff705d50.svg";